import {text_mod_27, } from "../text/Text.js";
export const module27 = {
  title:
    "§27. Слова, протилежні за значенням",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_27, },
    ]
  }
